import React from "react";
import {Badge, Box, Loader, Stack, Text} from "@mantine/core";
import {IconCheck, IconRobot, IconUser, IconX} from "@tabler/icons-react";
import {ChatMessage as ChatMessageType} from "../types/chatTypes";

interface ChatMessageProps {
    message: ChatMessageType;
}

export default function ChatMessage({message}: ChatMessageProps) {
    const isUser = message.role === 'user';

    if (message.isLoading) {
        return (
            <Box
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                    padding: '0.75rem',
                    marginBottom: '0.5rem',
                }}
            >
                <IconRobot size={20} style={{opacity: 0.7}}/>
                <Loader size="sm" type="dots"/>
            </Box>
        );
    }

    return (
        <Box
            style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: isUser ? 'flex-end' : 'flex-start',
                marginBottom: '0.75rem',
            }}
        >
            <Box
                style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: '0.5rem',
                    flexDirection: isUser ? 'row-reverse' : 'row',
                    maxWidth: '90%',
                }}
            >
                <Box
                    style={{
                        width: 28,
                        height: 28,
                        borderRadius: '50%',
                        backgroundColor: isUser ? 'var(--mantine-color-blue-6)' : 'var(--mantine-color-gray-7)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0,
                    }}
                >
                    {isUser ? <IconUser size={16}/> : <IconRobot size={16}/>}
                </Box>
                <Box
                    style={{
                        backgroundColor: isUser ? 'var(--mantine-color-blue-9)' : 'var(--mantine-color-dark-6)',
                        padding: '0.75rem 1rem',
                        borderRadius: isUser ? '1rem 1rem 0 1rem' : '1rem 1rem 1rem 0',
                    }}
                >
                    <Text size="sm" style={{whiteSpace: 'pre-wrap'}}>
                        {message.content}
                    </Text>
                </Box>
            </Box>

            {message.toolResults && message.toolResults.length > 0 && (
                <Stack gap="xs" style={{marginTop: '0.5rem', marginLeft: '2.25rem'}}>
                    {message.toolResults.map((result, index) => (
                        <Badge
                            key={index}
                            leftSection={result.success ? <IconCheck size={12}/> : <IconX size={12}/>}
                            color={result.success ? 'green' : 'red'}
                            variant="light"
                            size="sm"
                        >
                            {result.message.length > 50
                                ? result.message.substring(0, 50) + '...'
                                : result.message}
                        </Badge>
                    ))}
                </Stack>
            )}
        </Box>
    );
}
